/* Tabela de medidas (snippets/ui-size-guide.liquid).
 *
 * Tudo por delegacao no document: o botao que abre mora no rotulo da primeira opcao, e o
 * product-info.js re-renderiza o seletor de variantes inteiro a cada troca - listener
 * direto no botao morreria junto.
 *
 * - abre: <dialog>.showModal(), trava a rolagem da pagina e marca a linha do tamanho
 *   escolhido ("Selected"), lido do rotulo da primeira opcao no momento de abrir;
 * - fecha: botao X, Esc (nativo do dialog) ou clique no fundo escuro;
 * - unidade: in/lb e o padrao, como na referencia; a escolha fica no localStorage do
 *   visitante (so conveniencia - sem ele, volta ao padrao).
 * O dialog vai pro <body> na primeira abertura: dentro da coluna do produto ele herdaria
 * transform/overflow do tema.
 */
(function () {
  "use strict";

  var CHAVE = "ui_sg_unidade";

  function lerUnidade() {
    try {
      return localStorage.getItem(CHAVE) === "metrico" ? "metrico" : "imperial";
    } catch (e) {
      return "imperial";
    }
  }

  function gravarUnidade(u) {
    try {
      localStorage.setItem(CHAVE, u);
    } catch (e) {}
  }

  function aplicarUnidade(d, u) {
    d.classList.toggle("is-metrico", u === "metrico");
    var bs = d.querySelectorAll("[data-ui-sg-unidade]");
    for (var i = 0; i < bs.length; i++) {
      bs[i].setAttribute("aria-pressed", bs[i].getAttribute("data-ui-sg-unidade") === u ? "true" : "false");
    }
  }

  /* O tamanho escolhido e o valor mostrado no rotulo da PRIMEIRA opcao (Size). */
  function tamanhoAtual() {
    var el = document.querySelector("variant-selects [data-selected-value]");
    return el ? el.textContent.trim() : "";
  }

  function marcarSelecionado(d) {
    var t = tamanhoAtual();
    var ls = d.querySelectorAll("tr[data-ui-sg-size]");
    for (var i = 0; i < ls.length; i++) {
      ls[i].classList.toggle("is-sel", ls[i].getAttribute("data-ui-sg-size") === t);
    }
  }

  /* "Arraste a tabela" so aparece quando ela realmente nao cabe. */
  function avisoDeslize(d) {
    var w = d.querySelector(".ui-sg-envolve");
    var h = d.querySelector(".ui-sg-deslize");
    if (w && h) h.classList.toggle("is-visivel", w.scrollWidth > w.clientWidth + 1);
  }

  function abrir(d) {
    if (d.parentNode !== document.body) document.body.appendChild(d);
    aplicarUnidade(d, lerUnidade());
    marcarSelecionado(d);
    if (typeof d.showModal === "function") d.showModal();
    else d.setAttribute("open", "");
    document.documentElement.classList.add("ui-sg-travado");
    avisoDeslize(d);
  }

  function fechar(d) {
    if (typeof d.close === "function") d.close();
    else d.removeAttribute("open");
    document.documentElement.classList.remove("ui-sg-travado");
  }

  document.addEventListener("click", function (e) {
    var gatilho = e.target.closest('[id^="open-size-chart-"]');
    if (gatilho) {
      var d = document.querySelector('dialog[data-ui-sg="' + gatilho.id.slice(16) + '"]');
      if (d) {
        e.preventDefault();
        abrir(d);
      }
      return;
    }
    var dlg = e.target.closest("dialog[data-ui-sg]");
    if (!dlg) return;
    /* A casca cobre o dialog inteiro: clique com alvo no proprio dialog e no fundo. */
    if (e.target === dlg || e.target.closest("[data-ui-sg-fechar]")) {
      fechar(dlg);
      return;
    }
    var u = e.target.closest("[data-ui-sg-unidade]");
    if (u) {
      var val = u.getAttribute("data-ui-sg-unidade");
      aplicarUnidade(dlg, val);
      gravarUnidade(val);
      avisoDeslize(dlg);
    }
  });

  /* Esc fecha pelo navegador; aqui so destrava a rolagem. "close" nao borbulha. */
  document.addEventListener(
    "close",
    function (e) {
      if (e.target && e.target.matches && e.target.matches("dialog[data-ui-sg]")) {
        document.documentElement.classList.remove("ui-sg-travado");
      }
    },
    true
  );
})();
